import React from 'react';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import ImagesBlocks from './ImagesBlocks';
import TextProblematic from './TextProblematic';
import { breakpoint } from 'utils/mediaQueries';

const StyledGrid = styled(Grid)`
  height: 20rem;
  padding-top: 3%;
  margin-top: 3%;
  margin-bottom: 3%;
  ${breakpoint.down('lg')`
   margin-top: 7%`};
`;
const ProblematicBlocks = ({ data }) => {
  return (
    <StyledGrid
      container
      justify={'center'}
      alignItems={'flex-start'}
      id="problematicBlock"
    >
      <TextProblematic data={data} />
      <ImagesBlocks data={data} />
    </StyledGrid>
  );
};
export default ProblematicBlocks;
